import React from 'react';

const BackToTop = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#D5D1D9" />
      <path
        d="M16.1197 22.71L19.9997 18.83L23.8797 22.71C24.2697 23.1 24.8997 23.1 25.2897 22.71C25.6797 22.32 25.6797 21.69 25.2897 21.3L20.6997 16.71C20.3097 16.32 19.6797 16.32 19.2897 16.71L14.6997 21.3C14.3097 21.69 14.3097 22.32 14.6997 22.71C15.0897 23.09 15.7297 23.1 16.1197 22.71Z"
        fill="#231F20"
      />
    </svg>
  );
};

export default BackToTop;
